import { render, staticRenderFns } from "./UserListItemSlotTemplate.vue?vue&type=template&id=18489005&scoped=true&"
import script from "./UserListItemSlotTemplate.vue?vue&type=script&lang=js&"
export * from "./UserListItemSlotTemplate.vue?vue&type=script&lang=js&"
import style0 from "./UserListItemSlotTemplate.vue?vue&type=style&index=0&id=18489005&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18489005",
  null
  
)

export default component.exports